import { SORT_DATE, SORT_NAME } from 'constants/sortConstants';

export const EVENT_LIST_OPTIONS = [
  {
    value: SORT_DATE,
    label: 'À venir'
  },
  {
    value: SORT_NAME,
    label: 'Ordre alphabétique'
  }
];
